export default __webpack_public_path__ + "static/media/open-book.97755cd1.svg";